import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../utils/axios-general';
import * as CryptoJS from 'crypto-js';
import { setTimeout } from 'timers';
import EventBus from '../utils/event-bus';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export const store = new Vuex.Store({

  state: {
    user: {
      token: 123,
      id: null,
      user: '',
      role: '',
      isLogged: false,
      language: 'es_ES',
      tenant: '',
      isExternalLogin: null
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage
    })
  ],
  mutations: {
    authUser (state, userData) {
      state.user.token = userData.token;
      state.user.id = userData.id;
      state.user.user = userData.user;
      state.user.role = userData.role;
      state.user.isLogged = userData.isLogged;
      state.user.language = userData.language;
      state.user.isExternalLogin = userData.isExternalLogin;
    },
    storeUser (state, data) {
      state.user.user = data.user;
      state.user.role = data.role;
      state.user.tenant = data.tenant;
      state.user.language = data.language;
      state.user.isLogged = true;
      state.user.isExternalLogin = data.isExternalLogin;
    },
    clearData (state) {
      state.user.token = null;
      state.user.id = null;
      state.user.user = null;
      state.user.role = null;
      state.user.isLogged = false;
      state.user.language = 'es_ES';
      state.user.isExternalLogin = null;
    }
  },
  actions: {
    renewToken  ({ commit, state, dispatch }) {
      axios.defaults.headers.common['x-access-token'] = state.user.token;
      axios.get('renew')
        .then(res => {
          commit('authUser', {
            token: res.data.token,
            id: res.data._id,
            user: res.data.login,
            role: res.data.role,
            isLogged: true,
            language: res.data.language,
            isExternalLogin: !res.data.isLoginModule
          });
          if (!window.renew) {
            window.renew = setInterval(() => {
              dispatch('renewToken');
            }, 1000 * 60 * 15);
          }
        })
        .catch(() => dispatch('logout'));
    },
    setRenewTimer ({ commit, state, dispatch }, renewTime) {
      setTimeout(() => {
        axios.defaults.headers.common['x-access-token'] = state.user.token;
        axios.get('renew')
          .then(res => {
            commit('authUser', {
              token: res.data.token,
              id: res.data._id,
              isLogged: true,
              user: res.data.login,
              role: res.data.role,
              language: res.data.language,
              isExternalLogin: !res.data.isLoginModule
            });
            dispatch('setRenewTimer', (res.data.expiresIn) / 2);
          })
          .catch(() => dispatch('logout'));
      }, renewTime * 1000);
    },
    setLogoutTimer ({ commit }, expirationTime) {
      setTimeout(() => {
        commit('clearData');
      }, expirationTime * 1000);
    },
    logout ({ commit }) {
      commit('clearData');
      clearInterval(window.renew);
      window.renew = false;
      window.location.replace(window.location.protocol + '//' + window.location.host + '/#login');
      // router.replace('/login');
    },
    signup ({ commit }, authData) {
    },
    storeUser ({ commit, dispatch }, authData) {
      commit('storeUser', {
        role: authData.role,
        user: authData.login,
        language: authData.language,
        isExternalLogin: authData.isExternalLogin
      });
    },
    login ({ commit, dispatch }, authData) {
      const hash = CryptoJS.SHA256(authData.password);
      const pwd = hash.toString(CryptoJS.enc.Base64);
      axios.post('login', {
        login: authData.login,
        password: pwd,
        mobile: false,
        language: authData.language
      })
        .then(res => {
          commit('authUser', {
            token: res.data.token,
            user: res.data.login,
            id: res.data._id,
            role: res.data.role,
            isLogged: true,
            language: authData.language,
            isExternalLogin: !res.data.isLoginModule
          });
          commit('storeUser', {
            user: res.data.login,
            role: res.data.role,
            tenant: res.data.tenant,
            language: authData.language,
            isExternalLogin: !res.data.isLoginModule
          });
          dispatch('setRenewTimer', (res.data.expiresIn) / 2);
          dispatch('renewToken');
          EventBus.$emit('loginOk');
        }).catch(
          error => EventBus.$emit('loginError', { error: error })
        );
    }
  },
  getters: {
    /* Acceso tal que ~ this.$store.getters.user.[campos] */
    user (state) {
      return state.user.user ? state.user.user : '';
    },
    isAuthenticated (state) {
      return state.user.isLogged === true;
    },
    getid (state) {
      return state.user.user ? state.user.user._id : '';
    }
  }
});

export default store;
